import React from 'react';
import PropTypes from 'prop-types';
import { formatAmount } from "../../helpers/parsers";

const AMD = ({value}) => {
        if (!value) return <div>-</div>
        return (
            <div>
                {formatAmount(value)} <span style={{ fontWeight: 'bold' }}>֏</span>
            </div>
        )
    };

AMD.propTypes = {
    value: PropTypes.number.isRequired,
};

export default AMD;